import React, { useState, useContext } from "react"
import { useStaticQuery, graphql } from "gatsby"
import {
  SectionContainer,
  Title,
  BioCardWrapper,
  BioCardImg,
  BioCardContentContainer,
  ProfileCardContainerWrapper,
  ProfileCardSliderWrapper,
  ProfileCardWrapper,
  ProfileCardImageWrapper,
  ProfileCardName,
  ProfileCardTitle,
  ProfileCardTabletButton,
} from "./leadership-team.style"
import { UIContext } from "../shared/layout"
import Slider from "react-slick"
import useLightboxManager from "../shared/hooks/useLightboxManager"
import SectionDivider from "../shared/section-divider"
import Grid from "../shared/grid"
import CardFlip from "react-card-flip"
import { SliderLightbox as Lightbox } from "../../design-system/organisms/lightbox/"

const LightboxBioCard = ({ fluid, name, title, description }) => {
  return (
    <BioCardWrapper>
      <BioCardImg
        alt={`A profile shot of ${name}`}
        imgStyle={{ objectFit: "cover" }}
        fluid={fluid}
      />
      <BioCardContentContainer>
        <h3>{name}</h3>
        <h4>{title}</h4>
        <p>{description}</p>
      </BioCardContentContainer>
    </BioCardWrapper>
  )
}

const SectionProfileCard = ({
  src1,
  src2,
  name,
  title,
  onMouseUp,
  ...rest
}) => {
  const {
    state: { breakpoint },
  } = useContext(UIContext)

  const [isFlipped, _setIsFlipped] = useState(false)
  const setIsFlipped = (state) => {
    _setIsFlipped(breakpoint === "lg" && src2 && state)
  }

  return (
    <ProfileCardWrapper
      onMouseUp={breakpoint === "lg" ? onMouseUp : undefined}
      {...rest}
    >
      <ProfileCardImageWrapper
        onMouseEnter={() => setIsFlipped(true)}
        onMouseLeave={() => setIsFlipped(false)}
      >
        <CardFlip
          isFlipped={isFlipped}
          containerStyle={{
            width: "100% !important",
          }}
        >
          <img alt={`A profile shot of ${name}`} src={src1} />
          <img alt="" src={src2} />
        </CardFlip>
      </ProfileCardImageWrapper>
      <ProfileCardName>{name}</ProfileCardName>
      <ProfileCardTitle>{title}</ProfileCardTitle>
      {breakpoint === "md" && (
        <ProfileCardTabletButton onClick={onMouseUp}>
          Read Bio
        </ProfileCardTabletButton>
      )}
    </ProfileCardWrapper>
  )
}

const ProfileCardContainer = ({ children }) => {
  const {
    state: { breakpoint, clientLoaded },
  } = useContext(UIContext)

  return breakpoint === "sm" && clientLoaded ? (
    <ProfileCardSliderWrapper>
      <Slider>{children}</Slider>
    </ProfileCardSliderWrapper>
  ) : (
    <ProfileCardContainerWrapper>{children}</ProfileCardContainerWrapper>
  )
}

export default function LeadershipTeamSection() {
  const [isLightboxVisible, toggleLightbox, lightboxIndex] =
    useLightboxManager()

  const query = useStaticQuery(graphql`
    query {
      hongwei: file(
        relativePath: { eq: "4_COMPANY/About/Exec Main Images/hongwei.jpg" }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      hongweiPopout: file(
        relativePath: {
          eq: "4_COMPANY/About/Exec Bio Images/hongwei_popout.jpg"
        }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      hongweiAlt: file(
        relativePath: {
          eq: "4_COMPANY/About/Exec Hover Images/hongwei_alternate.jpg"
        }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      ed: file(
        relativePath: { eq: "4_COMPANY/About/Exec Main Images/ed.jpg" }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      edPopout: file(
        relativePath: { eq: "4_COMPANY/About/Exec Bio Images/ed_popout.jpg" }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      edAlt: file(
        relativePath: {
          eq: "4_COMPANY/About/Exec Hover Images/ed_alternate.jpg"
        }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      gerry: file(
        relativePath: { eq: "4_COMPANY/About/Exec Main Images/gerry.jpg" }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      gerryPopout: file(
        relativePath: { eq: "4_COMPANY/About/Exec Bio Images/gerry_popout.jpg" }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      gerryAlt: file(
        relativePath: {
          eq: "4_COMPANY/About/Exec Hover Images/gerry_alternate.jpg"
        }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      genny: file(
        relativePath: { eq: "4_COMPANY/About/Exec Main Images/genny.jpg" }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      gennyPopout: file(
        relativePath: { eq: "4_COMPANY/About/Exec Bio Images/genny_popout.jpg" }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      gennyAlt: file(
        relativePath: {
          eq: "4_COMPANY/About/Exec Hover Images/genny_alternate.jpg"
        }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      michael: file(
        relativePath: { eq: "4_COMPANY/About/Exec Main Images/michael.jpg" }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      michaelPopout: file(
        relativePath: {
          eq: "4_COMPANY/About/Exec Bio Images/michael_popout.jpg"
        }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      ian: file(
        relativePath: { eq: "4_COMPANY/About/Exec Main Images/ian.jpg" }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      ianPopout: file(
        relativePath: { eq: "4_COMPANY/About/Exec Bio Images/ian_popout.jpg" }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      paul: file(
        relativePath: { eq: "4_COMPANY/About/Exec Main Images/paul.jpg" }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      paulPopout: file(
        relativePath: { eq: "4_COMPANY/About/Exec Bio Images/paul_popout.jpg" }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      angela: file(
        relativePath: { eq: "4_COMPANY/About/Exec Main Images/angela.jpg" }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      angelaPopout: file(
        relativePath: {
          eq: "4_COMPANY/About/Exec Bio Images/angela_popout.jpg"
        }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      ami: file(
        relativePath: { eq: "4_COMPANY/About/Exec Main Images/ami.jpg" }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      amiAlt: file(
        relativePath: {
          eq: "4_COMPANY/About/Exec Hover Images/ami_alternate.jpg"
        }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      amiPopout: file(
        relativePath: { eq: "4_COMPANY/About/Exec Bio Images/ami_popout.jpg" }
      ) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 512) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <>
      {isLightboxVisible && (
        <Lightbox toggle={toggleLightbox} index={lightboxIndex}>
          <LightboxBioCard
            fluid={query.hongweiPopout.childImageSharp.fluid}
            name="Hongwei Liu"
            title="Founder & CEO"
            description="Hongwei is the Founder and CEO of Mappedin and has led the company’s growth from the founding team to the 65-person operation located in Waterloo. He was born in China, grew up in Ottawa, and moved to study Electrical Engineering at the University of Waterloo. Today, Hongwei focuses on thinking big, talking to customers, and finding amazing people to help build the dream."
          />

          <LightboxBioCard
            fluid={query.edPopout.childImageSharp.fluid}
            name="Ed Wei"
            title="Chief Technology Officer"
            description="Ed is Mappedin’s CTO and is responsible for leading the Development team that makes up over half the company. Ed studied Computer Science at the University of Waterloo and worked in Software roles at local companies - most notably, Research in Motion and Desire2Learn. Ed joined Mappedin in 2014 as the Director of Engineering and has helped to guide tremendous changes in our tech and products since that time."
          />
          <LightboxBioCard
            fluid={query.gerryPopout.childImageSharp.fluid}
            name="Gerry Beard"
            title="Chief Financial Officer"
            description="Gerry is Mappedin’s CFO and joined the team in 2019 after holding the same title at Waterloo’s Maluuba, Guelph’s SIHI Pumps Ltd, and Cambridge’s ATS. Gerry worked as the Director of Strategic Alliances during his time at Research in Motion and prior to that, he studied Accounting at the University of Waterloo."
          />
          <LightboxBioCard
            fluid={query.gennyPopout.childImageSharp.fluid}
            name="Genny Orser"
            title="VP of Marketing"
            description="Genny is Mappedin’s VP of Marketing and leads both the Product and Marketing teams. Genny grew up in Toronto and studied Sociology at the University of Guelph before working in Loyalty Marketing at Canadian Tire. Since joining Mappedin in 2016, Genny has grown our Marketing department from a one-person operation to the six-person team that she manages today."
          />
          <LightboxBioCard
            fluid={query.michaelPopout.childImageSharp.fluid}
            name="Michael Pasket"
            title="VP of Sales"
            description="Michael was born and raised in the Silicon Valley in California and attended the business program at Sonoma State University. Before joining Mappedin, Michael worked for Google Maps, where he led the international indoor mapping sales team. He joined Mappedin in 2018 as an Account Executive for the North American and Asian markets. Today, Michael manages the Sales team as the VP of Sales, focusing on creative solutions for property managers around the globe."
          />
          <LightboxBioCard
            fluid={query.ianPopout.childImageSharp.fluid}
            name="Ian Rutherford"
            title="Director of Customer Experience"
            description="Ian is Mappedin’s Director of Customer Experience and leads our Implementation and Success teams. Born and raised in Ottawa, Ian brings a wealth of knowledge and experience from his career in a variety of customer facing roles. Since joining in 2016, Ian has grown these teams while improving our success strategies to offer a best-in-class experience for all Mappedin customers."
          />
          <LightboxBioCard
            fluid={query.paulPopout.childImageSharp.fluid}
            name="Paul Bernhardt"
            title="Director of Engineering"
            description="Paul grew up in the City of Kitchener and attended Queen’s University where he specialized in Cognitive Science and received his Bachelor of Computing. He worked at local companies including Blackberry and Thalmic Labs before joining Mappedin in 2016 as a Developer Evangelist. Paul spent the next four years leading various development teams as a Software Development Manager before becoming Mappedin’s Director of Engineering. In this role, Paul oversees the SDK, DevOps, and Map Automation teams as well as the teams developing Mappedin's CMS and prebuilt applications."
          />
          <LightboxBioCard
            fluid={query.angelaPopout.childImageSharp.fluid}
            name="Angela Luong"
            title="Director of Finance"
            description="Angela is Mappedin’s Director of Finance and joined the team in 2021. She graduated from Wilfrid Laurier University with an MBA in Finance and has worked at a variety of notable companies in the technology sector, including Microsoft, Maluuba, and Communitech. In her role, Angela leads the Finance team and is focused on managing payroll, cash flow management, budgeting, financial reporting and analysis, and more."
          />
          <LightboxBioCard
            fluid={query.amiPopout.childImageSharp.fluid}
            name="Ami Asadi"
            title="Director of Product"
            description="Over the last 12 years, Ami has shipped multiple software products to millions of active users. He also founded two tech startups, raised capital, and successfully exited from those ventures. Ami joined Mappedin in 2020 as a Senior Product Manager and quickly rose to the Director of Product. In his day-to-day, along with working alongside major partners and customers, Ami is focused on developing product strategy across Mappedin’s product suite, including SDKs in different platforms, web applications, directories, and the CMS."
          />
        </Lightbox>
      )}
      <SectionDivider primaryColor="var(--slate)" />
      <SectionContainer>
        <Grid>
          <Title>Leadership Team</Title>
          <ProfileCardContainer>
            <SectionProfileCard
              src1={query.hongwei.publicURL}
              src2={query.hongweiAlt.publicURL}
              name="Hongwei Liu"
              title="Founder & CEO"
              onMouseUp={() => toggleLightbox(0)}
            />
            <SectionProfileCard
              src1={query.ed.publicURL}
              src2={query.edAlt.publicURL}
              name="Ed Wei"
              title="Chief Technology Officer"
              onMouseUp={() => toggleLightbox(1)}
            />
            <SectionProfileCard
              src1={query.gerry.publicURL}
              src2={query.gerryAlt.publicURL}
              name="Gerry Beard"
              title="Chief Financial Officer"
              onMouseUp={() => toggleLightbox(2)}
            />
            <SectionProfileCard
              src1={query.genny.publicURL}
              src2={query.gennyAlt.publicURL}
              name="Genny Orser"
              title="VP of Marketing"
              onMouseUp={() => toggleLightbox(3)}
            />
            <SectionProfileCard
              src1={query.michael.publicURL}
              name="Michael Pasket"
              title="VP of Sales"
              onMouseUp={() => toggleLightbox(4)}
            />
            <SectionProfileCard
              src1={query.ian.publicURL}
              name="Ian Rutherford"
              title="Director of Customer Experience"
              onMouseUp={() => toggleLightbox(5)}
            />
            <SectionProfileCard
              src1={query.paul.publicURL}
              name="Paul Bernhardt"
              title="Director of Engineering"
              onMouseUp={() => toggleLightbox(6)}
            />
            <SectionProfileCard
              src1={query.angela.publicURL}
              name="Angela Luong"
              title="Director of Finance"
              onMouseUp={() => toggleLightbox(7)}
            />
            <SectionProfileCard
              src1={query.ami.publicURL}
              src2={query.amiAlt.publicURL}
              name="Ami Asadi"
              title="Director of Product"
              onMouseUp={() => toggleLightbox(8)}
            />
          </ProfileCardContainer>
        </Grid>
      </SectionContainer>
      <SectionDivider primaryColor="var(--slate)" flip />
    </>
  )
}
